import React from "react";
import { useTranslation } from "react-i18next";

function TextFieldAtom(props) {
    const { label, type, className, placeholder, value, onChange, error = '', required = false, errorTextPlaceholder = {}, ...rest } = props;
    const { t } = useTranslation();
    return (
        <>
            {label ? <label>{label}</label> : ''}
            <input
                type={type || 'text'}
                className={className || "form-control"}
                placeholder={(required ? `${placeholder}*` : placeholder) || ''}
                value={value}
                onChange={onChange}
                {...rest}
            />
            {error ? <p className="text-danger">{t(error, errorTextPlaceholder)}</p> : ''}
        </>
    );
}

export default TextFieldAtom;
